import { createMainPageRoutes } from '@completeanatomy/main-screen';

export const mainPageRoutes = createMainPageRoutes();
